<template>
  <v-container fluid>
    <v-form id="login-form" v-model="valid" ref="form" class="wrapper lg mx-auto pa-4 mt-4">
      <v-layout row wrap>
        <v-flex xs5 pa-3>
          <v-text-field
               label="Email"
               v-model="username"
               :rules="usernameRules"
               required
               class="input-group--focused"
               ></v-text-field>
        </v-flex>
        <v-flex xs5 pa-3>
          <v-text-field
               label="Password"
               v-model="password"
               :rules="passwordRules"
               type='password'
               required
               ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-3>
          <v-btn
               @click="handleSubmit"
               color="success"
               :disabled="!valid"
               >
               submit
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  data () {
    return {
      username: '',
      usernameRules: [v => !!v || 'Username is required'],
      password: '',
      passwordRules: [v => !!v || 'Password is required'],
      submitted: false,
      error: false,
      success: false,
      valid: false
    };
  },
  computed: {
    ...mapState('account', ['status'])
  },
  created () {
    // reset login status
    this.logout();
  },
  methods: {
    ...mapActions('account', ['login', 'logout']),
    handleSubmit (e) {
      this.submitted = true;
      const { username, password } = this;
      if (username && password) {
        this.login({ username, password });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Login.vue